import { createTheme } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';

export const theme = createTheme({
	typography: {
		fontSize: 20,
		h4: {
			fontSize: 24
		}
	},
	palette: {
		primary: {
			main: '#a8653b'
		},
		secondary: {
			main: '#000000',
			contrastText: '#fff'
		}
	},
	zIndex: {
		drawer: '10'
	}
});
